module.exports = __webpack_public_path__ + "static/media/2.14835ed1.webp";